import React from 'react';
import { VerificationWizardProvider } from './VerificationWizardContext';
import VerificationWizardContent from './VerificationWizardContent';
import '../../components/wizard/ClinicCreationWizard.css';

interface VerificationWizardModalProps {
  isOpen: boolean;
  clinicId: number | null;
  onClose: () => void;
  onComplete: () => void;
}

const VerificationWizardModal: React.FC<Readonly<VerificationWizardModalProps>> = ({
  isOpen,
  clinicId,
  onClose,
  onComplete,
}) => {
  if (!isOpen || !clinicId) return null;

  // No backdrop close: the wizard closes through Back to Queue or Escape,
  // which ask first when steps have been worked through (SLV2-4049).
  return (
    <div className="wizard-overlay">
      <VerificationWizardProvider clinicId={clinicId}>
        <VerificationWizardContent onClose={onClose} onComplete={onComplete} />
      </VerificationWizardProvider>
    </div>
  );
};

export default VerificationWizardModal;
